import { render, staticRenderFns } from "./SponsorSectionEdit.vue?vue&type=template&id=7639f52d&scoped=true&"
import script from "./SponsorSectionEdit.vue?vue&type=script&lang=js&"
export * from "./SponsorSectionEdit.vue?vue&type=script&lang=js&"
import style0 from "./SponsorSectionEdit.vue?vue&type=style&index=0&id=7639f52d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7639f52d",
  null
  
)

export default component.exports